import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, Stack, styled, Backdrop, CircularProgress } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';
import { m } from 'framer-motion';
import { useDispatch } from 'react-redux';

import Image from '../../components/Image';
import useLocales from '../../hooks/useLocales';
import conObj from '../../utils/connection-assistant';
import { getOperatingSystem } from '../../utils/formatObject';
import CustomModal from '../../components/CustomModal';
import { SupportedDownloadGames } from './Const';
import GameDownload from './GameDownload';
import Iconify from '../../components/Iconify';
import { openModal } from '../../redux/slices/authUiSlice';
import useResponsive from '../../hooks/useResponsive';
import BrandLogo from '../../assets/brand-logo.png';

const ModalTitle = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontWeight: 600,
  fontSize: 20,
}));

const ModalSubTitle = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontSize: 15,
}));

const ModalButton = styled(Button)(({ theme }) => ({
  background: '#dd0000',
  padding: '10px 3rem',
  width: 'auto',
  marginLeft: 'auto !important',
  marginRight: 'auto !important',
  marginTop: 2,
  display: 'block',
}));

const ModalButtonText = styled(Typography)(({ theme }) => ({
  color: 'white',
  fontWeight: 600,
  fontSize: 15,
  textShadow: '0px 1px 2px black',
}));

const MaintenanceText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  color: '#ac0707',
  fontWeight: 600,
  textShadow: '0px 0px 1px #7f7f7f',
  fontSize: '3.5vw',
  [theme.breakpoints.up('xs')]: {
    fontSize: '3vw',
  },
  // [theme.breakpoints.up('sm')]: {
  //   fontSize: '2vw',
  // },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.5vw',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1.2rem',
  },
}));

const PopularCompanies = [
  {
    companySlug: 'megah5-slot',
    popularity: 'new',
  },
  {
    companySlug: 'ak-pragmatic-slot',
    popularity: 'hot',
  },
  {
    companySlug: 'awc-jili-slot',
    popularity: 'hot',
  },
];

const ProviderItemWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 6,
  width: '100%',
}));

const ProviderCircle = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ isActive }) => ({
  width: 60,
  height: 60,
  borderRadius: '50%',
  background: isActive ? 'linear-gradient(180deg, #ffe08d, #e09944)' : '#2E2E2E',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  transition: 'all 0.3s ease',
}));

const GameContainer = ({
  item,
  companySlug = null,
  containerSx = {},
  imgWrapperSx = {},
  titleSx = {},
  isCategorized = false,
  isParent = false,
  isPopular = false,
  noBorder = false,
  lastSlotRef = null,
  isAddAnimation = false,
  isActive = false,
  onSelectGame,
}) => {
  const isAuthenticated = localStorage.getItem('accessToken');

  const dispatch = useDispatch();

  const { translate } = useLocales();

  const [isShowOverlay, setIsShowOverlay] = useState(false);

  const [gameDownloadData, setGameDownloadData] = useState(null);

  const _openConfirm = {
    open: false,
    content: '',
    onConfirm: null,
  };

  const [openConfirm, setOpenConfirm] = useState(_openConfirm);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const isDesktop = useResponsive('up', 'lg');

  // const handleGetPrompt = (code) => {
  //   conObj
  //     .post(`games/launch/${code}.json`, {
  //       system_os: getOperatingSystem(),
  //       is_mobile: isMobile ? 1 : 0,
  //       return_url: window.location.href,
  //     })
  //     .then((res) => {
  //       if (res.status === 200) {
  //         const { prompt_confirm: promptConfirm, data } = res?.data?.data;
  //         if (promptConfirm) {
  //           setOpenConfirm({
  //             open: true,
  //             content: promptConfirm,
  //             onConfirm: () => {
  //               setOpenConfirm(_openConfirm);
  //               handleLaunchGame(code, true);
  //             },
  //           });
  //         } else {
  //           // handleLaunchGame(code, false);
  //           const newTab = window.open();

  //           if (newTab) {
  //             // Only execute this if the new window was successfully created
  //             newTab.document.write(
  //               "<body style='background-image: url(https://zk7web.s3.ap-south-1.amazonaws.com/home/game-bg.png); background-repeat: no-repeat; background-attachment: fixed; background-size: cover; background-position: center;'><div style='width: 100%; height: 100%; font-family: Roboto, sans-serif; font-size: 2rem; color: white; font-weight: 700; display: flex; align-items: center; justify-content: center; background-image: linear-gradient(#eec85c, #a5732c); -webkit-background-clip: text; -webkit-text-fill-color: transparent;'>Loading game site</div></body>"
  //             );

  //             newTab.location.href = res.data?.data?.data?.url;
  //           } else {
  //             const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
  //             enqueueSnackbar(
  //               `Failed to open new window/tab. Please Disable Pop-up Blockers in the settings.`,
  //               snackbarOptions
  //             );
  //             console.error('Failed to open new window/tab. Please Disable Pop-up Blockers in the settings.');
  //           }
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
  //       enqueueSnackbar(err.message, snackbarOptions);
  //       console.log(`Game Container: Server Error: ${err.message}`);
  //     });
  // };

  const handleLaunchGame = (code) => {
    setIsSubmitting(true);

    let newTab = null;

    if (!SupportedDownloadGames.includes(code)) {
      newTab = window.open();

      newTab.document.write(`
        <html>
          <head>
            <title>BD888 - Loading</title>
            <style>
              body {
                margin: 0;
                height: 100vh;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                font-family: 'Segoe UI', Roboto, sans-serif;

                /* BD888 header gradient */
                background: linear-gradient(90deg, #1f4d2b 0%, #2e7d32 100%);
                color: white;
              }

              .logo {
                width: 200px;
                margin-bottom: 20px;
              }

              .loading-text {
                font-size: 22px;
                font-weight: 600;
                color: #ffffff;
              }

              .highlight {
                color: #f4c542; /* gold accent like BD888 */
              }

              .dots::after {
                content: '';
                animation: dots 1.5s infinite;
              }

              @keyframes dots {
                0% { content: ''; }
                33% { content: '.'; }
                66% { content: '..'; }
                100% { content: '...'; }
              }
            </style>
          </head>

          <body>
            <img 
              class="logo" 
              src=${BrandLogo}
              alt="BD888 Logo"
            />

            <div class="loading-text">
              Loading <span class="highlight">Game</span><span class="dots"></span>
            </div>
          </body>
        </html>
      `);
    }

    conObj
      .post(`games/launch/${code}.json`, {
        system_os: getOperatingSystem(),
        is_mobile: isMobile ? 1 : 0,
        return_url: window.location.href,
        // ...(passConfirm && { confirmed_prompt: 1 }),
      })
      .then((res) => {
        if (res.status === 200) {
          const { status, data } = res.data.data;
          if (status === 1) {
            // Means its game download
            if (!newTab) setGameDownloadData({ ...data, code });
            // Means its normal launch
            else newTab.location.href = data?.url;
            setIsSubmitting(false);
          }
        }
      })
      .catch((err) => {
        const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
        enqueueSnackbar(err.message, snackbarOptions);
        console.log(`Server Error: ${err.message}`);
        setIsSubmitting(false);
        if (newTab) newTab.close();
      });
  };

  const getPopularity = () => {
    const matchedItem = PopularCompanies.find((f) => f.companySlug === item?.slug);

    if (matchedItem) {
      return matchedItem?.popularity === 'hot' ? (
        <Image
          src={require('../../assets/home/hot.png')}
          sx={{ position: 'absolute', top: '-10px', right: '-5px', width: '36px', height: 'auto' }}
        />
      ) : (
        <Image
          src={require('../../assets/home/new.png')}
          sx={{ position: 'absolute', top: '-8px', right: '-2px', width: '32px', height: 'auto' }}
        />
      );
    }

    return '';
  };

  return (
    // Container
    <Box
      sx={{ width: '100%', overflow: 'hidden', height: '100%', position: 'relative' }}
      {...(isAddAnimation
        ? {
            component: m.div,
            animate: {
              scale: [1, 0.9, 1],
            },
            transition: {
              duration: 3,
              ease: 'easeInOut',
              repeatDelay: 0,
              repeat: Infinity,
            },
          }
        : {})}
    >
      {isCategorized ? (
        <Box
          onClick={() => {
            if (item?.is_coming_soon || item?.is_maintenance_mode) return;

            if (item?.is_single_game && item?.single_game_game_code && isAuthenticated) {
              handleLaunchGame(item?.single_game_game_code);
              return;
            }

            if (onSelectGame) {
              onSelectGame(item);
              return;
            }

            if (isAuthenticated) {
              if (item?.is_single_game && item?.single_game_game_code) handleLaunchGame(item?.single_game_game_code);
              else handleLaunchGame(item.code);
            } else {
              dispatch(
                openModal({
                  view: 'login',
                })
              );
            }
          }}
          sx={{
            width: '100%',
            cursor: item?.is_coming_soon || item?.is_maintenance_mode ? 'not-allowed' : 'pointer',
          }}
        >
          {/* IMAGE CONTAINER */}
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              aspectRatio: '1 / 1',
              borderRadius: '12px',
              overflow: 'hidden',

              // disable hover effect on mobile
              '&:hover .game-image': {
                transform: {
                  xs: 'none',
                  md: 'scale(1.08)',
                },
              },

              '&:hover .hover-overlay': {
                opacity: {
                  xs: 0,
                  md: item?.is_coming_soon || item?.is_maintenance_mode ? 0 : 1,
                },
              },
            }}
          >
            {/* IMAGE */}
            <Box
              component="img"
              className="game-image"
              src={item?.photo_url || item?.icon_url || ''}
              alt={item?.name}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transition: 'transform 0.4s ease-in-out',
                filter: item?.is_coming_soon || item?.is_maintenance_mode ? 'brightness(0.5)' : 'none',
              }}
            />

            {/* HOVER OVERLAY (desktop only) */}
            <Box
              className="hover-overlay"
              sx={{
                position: 'absolute',
                inset: 0,
                display: {
                  xs: 'none',
                  md: 'flex',
                },
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(0,0,0,0.25)',
                backdropFilter: 'blur(8px)',
                opacity: 0,
                transition: 'opacity 0.3s ease',
                zIndex: 2,
              }}
            >
              {/* <Typography
                sx={{
                  color: '#fff',
                  fontSize: '14px',
                  mb: 2,
                }}
              >
                {translate('favourite')}
              </Typography> */}

              <Box
                sx={{
                  px: 4,
                  py: 1,
                  borderRadius: '50px',
                  background: 'linear-gradient(180deg, #FFD580 0%, #E6A84A 100%)',
                  color: '#333',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                }}
              >
                {translate('play_now')}
              </Box>
            </Box>

            {/* COMING SOON */}
            {item?.is_coming_soon && (
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 3,
                }}
              >
                <Box sx={{ width: '70%' }}>
                  <Image src={require('../../assets/coming_soon.webp')} sx={{ width: '100%' }} />
                </Box>
              </Box>
            )}

            {/* DESKTOP BOTTOM INFO */}
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
                p: 1,
                display: {
                  xs: 'none',
                  md: 'flex',
                },
                justifyContent: 'space-between',
                alignItems: 'center',
                background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
                zIndex: 3,
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '12px',
                }}
              >
                {item?.name}
              </Typography>

              {/* <Iconify icon="mdi:heart-outline" width={18} color="#fff" /> */}
            </Box>
          </Box>

          <Typography
            sx={{
              mt: 0.5,
              fontSize: '12px',
              fontWeight: 500,
              textAlign: 'start',
              color: '#333',
              display: {
                xs: 'block',
                md: 'none',
              },
            }}
          >
            {item?.name}
          </Typography>
        </Box>
      ) : (
        <Box>
          <Box>
            {isDesktop && (
              <ProviderItemWrapper>
                <ProviderCircle
                  isActive={isActive}
                  onClick={() => {
                    if (item?.is_blocked_by_promotion || item?.is_coming_soon || item?.is_maintenance_mode) return;

                    if (item?.is_parent) {
                      if (onSelectGame) {
                        onSelectGame(item);
                      }
                      return;
                    }

                    if (!isCategorized) {
                      if (onSelectGame) {
                        onSelectGame(item);
                      }
                      return;
                    }

                    if (!isAuthenticated) {
                      dispatch(
                        openModal({
                          view: 'login',
                        })
                      );
                      return;
                    }

                    if (item?.is_single_game && item?.single_game_game_code) {
                      handleLaunchGame(item?.single_game_game_code);
                    } else {
                      handleLaunchGame(item.code);
                    }
                  }}
                >
                  <Image
                    src={item?.brand_logo_url}
                    alt={item.name}
                    sx={{
                      width: 70,
                      objectFit: 'contain',
                      cursor: item?.is_blocked_by_promotion ? 'not-allowed' : 'pointer',
                      opacity: item?.is_blocked_by_promotion ? 0.3 : 1,
                      filter: `brightness(${item.is_maintenance_mode || item?.is_coming_soon ? '0.5' : '1'})`,
                    }}
                  />
                </ProviderCircle>

                <Typography
                  variant="caption"
                  sx={{
                    color: '#000000',
                    textAlign: 'center',
                    fontSize: 12,
                    opacity: item?.is_blocked_by_promotion ? 0.5 : 1,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '80px',
                  }}
                >
                  {item.name}
                </Typography>
              </ProviderItemWrapper>
            )}

            {!isDesktop && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  gap: 1,
                  width: 50,
                  height: 50,
                }}
                onClick={() => {
                  if (item?.is_blocked_by_promotion || item?.is_coming_soon || item?.is_maintenance_mode) return;

                  if (item?.is_parent) {
                    if (onSelectGame) {
                      onSelectGame(item);
                    }
                    return;
                  }

                  if (!isCategorized) {
                    if (onSelectGame) {
                      onSelectGame(item);
                    }
                    return;
                  }

                  if (!isAuthenticated) {
                    dispatch(
                      openModal({
                        view: 'login',
                      })
                    );
                    return;
                  }

                  if (item?.is_single_game && item?.single_game_game_code) {
                    handleLaunchGame(item?.single_game_game_code);
                  } else {
                    handleLaunchGame(item.code);
                  }
                }}
              >
                <Image src={item?.brand_logo_url} sx={{ width: 70 }} />
                <Typography sx={{ color: '#000000', fontSize: '9px' }}>{item.name}</Typography>
              </Box>
            )}

            {item?.is_coming_soon && (
              <Box
                sx={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  zIndex: 2,
                }}
              >
                <Box sx={{ width: '70%', mt: 1 }}>
                  <Image src={require('../../assets/coming_soon.webp')} sx={{ width: '100%' }} />
                </Box>
              </Box>
            )}

            {getPopularity()}
          </Box>
          {isPopular && (
            <Button
              disabled={item?.is_coming_soon}
              sx={{
                width: '100%',
                marginTop: 1,
                backgroundColor: 'transparent !important',
                backgroundSize: '100% 100%',
                border: 0,
                color: '#fff',
                borderRadius: 1,
                padding: '3px 0',
                fontSize: '11px',
                backgroundImage: `url('${require('../../assets/home/play-btn bg.png')}')`,
                minWidth: '100%',
              }}
              onClick={() => {
                if (item?.is_coming_soon) return;

                // if (companySlug) {
                //   if (!item?.is_maintenance_mode && !item?.is_single_game) {
                //     navigate(`/games/${companySlug}/${item.id}`);
                //     return;
                //   }
                // }

                if (!isCategorized) {
                  navigate(`/games/${item?.category_slug}/${item.id}?name=${item.name}`);
                  return;
                }

                if (isAuthenticated) {
                  if (item?.is_single_game && item?.single_game_game_code)
                    handleLaunchGame(item?.single_game_game_code);
                  else handleLaunchGame(item.code);
                } else
                  dispatch(
                    openModal({
                      view: 'login',
                    })
                  );
              }}
            >
              {translate('play').toUpperCase()}
            </Button>
          )}
        </Box>
      )}
      {item.is_maintenance_mode && (
        <Box sx={{ position: 'absolute', bottom: 0, display: 'flex', justifyContent: 'center', width: '100%' }}>
          <MaintenanceText>{translate('in_maintenance')}</MaintenanceText>
        </Box>
      )}

      {openConfirm?.open && (
        <CustomModal
          open={openConfirm?.open}
          onClose={() => setOpenConfirm(_openConfirm)}
          isBackdropClosable={false}
          // sx={{ overflow: 'hidden' }}
        >
          <Box sx={{ px: 2, pt: 5, pb: 3 }}>
            <ModalTitle>{openConfirm?.content}</ModalTitle>
            <Stack direction="row" sx={{ mt: 2 }}>
              <ModalButton onClick={openConfirm?.onConfirm} disabled={isSubmitting}>
                <ModalButtonText>{translate('yes')}</ModalButtonText>
              </ModalButton>
              <ModalButton onClick={() => setOpenConfirm(_openConfirm)}>
                <ModalButtonText>{translate('no')}</ModalButtonText>
              </ModalButton>
            </Stack>
          </Box>
        </CustomModal>
      )}

      {isSubmitting ? (
        <Backdrop open={true} sx={{ zIndex: 9999 }}>
          <CircularProgress />
        </Backdrop>
      ) : (
        <CustomModal
          open={!!gameDownloadData}
          onClose={() => setGameDownloadData(null)}
          title={gameDownloadData?.code}
          PaperProps={{
            sx: {
              backgroundColor: '#232734',
              border: '1px solid white',
            },
          }}
        >
          <GameDownload data={gameDownloadData} />
        </CustomModal>
      )}
    </Box>
  );
};

GameContainer.propTypes = {
  item: PropTypes.object,
  onClick: PropTypes.func,
  containerSx: PropTypes.object,
  imgWrapperSx: PropTypes.object,
  titleSx: PropTypes.object,
  isCategorized: PropTypes.bool,
  isParent: PropTypes.bool,
  isPopular: PropTypes.bool,
  noBorder: PropTypes.bool,
};

export default GameContainer;
